import React, { Fragment, useEffect, useState } from "react";
import { CUSTOM_REPLY_PROPS } from "./interface";
import CardBoard from "./board/CardBoard";
import GambleBoard from "./board/GambleBoard";

export default function CustomReply({
  colors,
  betReplyResponse,
}: CUSTOM_REPLY_PROPS) {
  const [hasGamble, setHasGamble] = useState<boolean>(false);

  const {
    cardsfirst,
    cardsfinal,
    lockState,
    winpositions,
    doubleup,
  } = betReplyResponse;

  useEffect(() => {
    doubleup.length > 0 && setHasGamble(true);
  }, [doubleup]);

  return (
    <Fragment>
      <h3>Initial Hand</h3>
      <CardBoard hand={cardsfirst} colors={colors} selected={lockState} />
      <h3>Player Hand</h3>
      <CardBoard
        hand={cardsfinal}
        colors={colors}
        winningCombination={winpositions}
      />
      {hasGamble && (
        <Fragment>
          <h3>Gamble</h3>
          <GambleBoard content={doubleup} colors={colors} />
        </Fragment>
      )}
    </Fragment>
  );
}
